import type { ProductPlanOption } from './api';

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export type AppPlanAssignmentSelection = {
  workspaceId: string | null | undefined;
  selectedPlan: ProductPlanOption | null | undefined;
};

export type AppPlanAssignmentResolution =
  | { ok: true; workspaceId: string; productPlanId: string }
  | { ok: false; reason: 'workspace' | 'plan' };

export function resolveAppPlanAssignment(
  selection: AppPlanAssignmentSelection,
): AppPlanAssignmentResolution {
  const workspaceId = selection.workspaceId?.trim() ?? '';
  if (!UUID_PATTERN.test(workspaceId)) {
    return { ok: false, reason: 'workspace' };
  }

  const productPlanId = selection.selectedPlan?.product_plan_id?.trim() ?? '';
  if (!UUID_PATTERN.test(productPlanId)) {
    return { ok: false, reason: 'plan' };
  }

  return { ok: true, workspaceId, productPlanId };
}
